import React, { useEffect, useState } from "react";
import HttpApis from "../../services/HttpApis";
import { useNavigate, useParams } from "react-router-dom";
import Standard from "../Standard/standard";
import Banner from "../Banner/bannner";
import SpinLoader from "../loader/SpinLoader";
import NoDataFound from "../noData/NoDataFound";

const CreatorList = () => {
  const [contents, setContents] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { id } = useParams();
  const fetchContents = async (creatorId) => {
    try {
      setLoading(true);
      let response;
      if (creatorId) {
        response = await HttpApis.getCreatorListbycontentId(creatorId);
      } else {
        response = await HttpApis.getCreatorList();
      }

      const data = response?.data?.data || [];
      setContents(Array.isArray(data) ? data : [data]);
    } catch (error) {
      console.error("Error fetching content list:", error);
      setContents([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContents(id);
  }, [id]);

const handleItemClick = async (item, typeSlug) => {
  if (!item) return;

  const creatorId =
    typeof item === "number"
      ? item
      : typeof item === "string"
        ? item
        : item?.id || item?.creator_id;

  const isNumeric = !isNaN(Number(creatorId));

  if (!isNumeric) {
    // Non-numeric → navigate immediately
    navigate(`/details/${typeSlug || "movies"}/${creatorId}`);
    return;
  }

  try {
    const response = await HttpApis.getCreatorListbyId(creatorId);
    const creatorData = response?.data?.data?.creator;

    if (creatorData?.id) {
      navigate(`/creators/${creatorData.id}`);
    } else {
      // Fallback if API fails
      navigate(`/creators/${creatorId}`);
    }
  } catch (error) {
    console.error("Error fetching creator by ID:", error);
    navigate(`/creators/${creatorId}`); // fallback navigation
  }
};



  if (loading) return <SpinLoader/>;
  if (contents.length === 0) return <NoDataFound message="No content found."/>;
  const bannerItem = contents[0];
  const remainingItems = contents.slice(1);
  const bannerImage =
    bannerItem?.channel_banner ||
    bannerItem?.landscape ||
    bannerItem?.portrait ||
    bannerItem?.profile_img ||
    "";

  const sectionDataForBanner = [
    {
      type: "carousel",
      items: bannerItem
        ? [
          {
            id: bannerItem.id,
            slug: bannerItem.slug,
            name: bannerItem.name,
            thumbnail_image: bannerImage,
            genres: bannerItem.genres,
          },
        ]
        : [],
    },
  ];

  const sectionData = [
    {
      type: "gallery",
      title: id ? "Creator Content" : "All Creators",
      items: remainingItems.map((item) => ({
        id: item.id,
        slug: item.slug,
        name: item.name,
        rating: item.rating,
        genres: item.genres,
        access: item.access,
        duration: item.duration,
        dateUploaded: item.dateUploaded,
        views: item.views,
        thumbnail_image:
          item.profile_img || item.landscape || item.portrait || "", // FIXED
      })),
    },
  ];

  return (
    <div>
      {bannerItem && (
        <Banner
          sectionData={sectionDataForBanner}
          onItemClick={handleItemClick}
          isGenre={false}
        />
      )}
      <Standard
        sectionData={sectionData}
        handleDetails={handleItemClick}
        isGenre={false}
      />
    </div>
  );
};

export default CreatorList;
